<template>
  <v-dialog
    v-model="show"
    max-width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        depressed
        v-bind="attrs"
        class="mb-2"
        v-on="on"
      >
        {{ $t('TaskList.SickLeave.viewInstructionRecord') }}
        <!-- 工作指示記錄 -->
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-body-1">
        {{ $t('TaskList.SickLeave.viewInstructionRecord') }}
      </v-card-title>
      <v-simple-table class="mx-2">
        <tbody>
          <tr
            v-for="item in workItemHistory"
            :key="`ancestor${item.workItemId}`"
          >
            <td class="pr-0">
              {{ momentWithHyphen(item.completedTime).format('YYYY-MM-DD HH:mm') }}
            </td>
            <td
              class="pr-0"
              style="min-width: 80px;"
            >
              <v-tooltip
                top
                color="black"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                  >{{ $chPtObjData('chinStaffName', item) }}</span>
                </template>
                <span>{{ item.euid }}</span>
              </v-tooltip>
            </td>
            <td class="pr-0">
              {{ item.message }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="show = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'

export default {
  props: {
    workItemHistory: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      show: false,
      loadingAncestor: false
    }
  },
  watch: {
  },
  methods: {
    momentWithHyphen
  }
}
</script>
